import styled, { css } from 'styled-components';

import { breakpoints, Heading } from '@notino/react-styleguide';

const commonCss = css<{ newPdDesignEnabled: boolean }>`
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  flex-basis: 100%;
  line-height: 1.18;

  ${({ newPdDesignEnabled }) =>
    newPdDesignEnabled
      ? css`
          margin: 0;
          font-weight: 500 !important;
        `
      : css`
          margin: 1.25rem 0 1rem 0;
          font-size: 1.125rem;
          font-weight: bold;
        `}

  @media (min-width: ${({ newPdDesignEnabled }) =>
    newPdDesignEnabled ? breakpoints.lg : breakpoints.md}) {
    font-size: 1.75rem;
    display: block;
    cursor: text;

    ${({ newPdDesignEnabled }) =>
      newPdDesignEnabled
        ? css`
            margin: 3rem 0 1.25rem;
          `
        : css`
            margin: 3rem 0 1.75rem;
          `}
  }
`;

export const Title = styled(Heading.H2)`
  ${commonCss}
`;

export const TitleButton = styled.button`
  background: transparent;
  width: 100%;
  border: 0;
  color: inherit;
  ${commonCss}
`;

export const ChevronIconWrapper = styled.span<{ newPdDesignEnabled: boolean }>`
  cursor: pointer;
  text-align: center;
  width: 1rem;
  line-height: 1;

  @media (min-width: ${({ newPdDesignEnabled }) =>
      newPdDesignEnabled ? breakpoints.lg : breakpoints.md}) {
    display: none;
  }
`;
